import styled from "styled-components";

export default styled.div`
  position: absolute;

  .icon-picker {
  }
`;
